import { Box, TextField } from '@mui/material';
import { LabeledSwitcher, UsageInformationIcon } from '@/shared/ui';

interface Props {
  name: string;
  isDefault: boolean;
  onNameChange: (value: string) => void;
  onIsDefaultChange: (value: boolean) => void;
  nameError?: string;
}

export function PresetForm({
  name,
  isDefault,
  onNameChange,
  onIsDefaultChange,
  nameError,
}: Props) {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      // needed to prevent ripple effects on preset item in select
      onFocus={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <TextField
        label="Preset name"
        fullWidth
        InputProps={{
          inputProps: {
            sx: {
              py: 1.5,
              px: 2,
              height: 16,
              fontWeight: 400,
              fontSize: '0.875rem',
              lineHeight: '1rem',
              letterSpacing: 0,
            },
          },
          sx: {
            borderRadius: 2,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: '0.875rem',
            top: -6,

            '&.MuiInputLabel-shrink': {
              top: 0,
              fontSize: '1rem',
            },
          },
        }}
        error={!!nameError}
        helperText={nameError}
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1.5 }}>
        <LabeledSwitcher
          label="Set as default"
          value={isDefault}
          onChange={onIsDefaultChange}
        />
        <UsageInformationIcon
          sx={{ maxWidth: 200 }}
          placement="right"
          tooltipText="This preset will be automatically loaded when you open this view"
        />
      </Box>
    </Box>
  );
}
